export const colorReferenceApprover = {
    devuelta: 4,
    aprobada: 3,
    fijada: 5,
    pendiente: 2,
    sinAprobacion: 1,
    cancelada: 0 // The 'cancelled' state is not defined for the approver.
  };
  
  export const colorReferenceInspector = {
    enviadaSE: 2,
    errorSE: 4,
    actuarInspector: 7,
    inspeccionada: 5,
    paquetizada: 6,
    cancelada: 3,
    revision: 0
  };
  